import { apiClient } from "@/lib/apiClient";
import type { TradeMatchResponse } from "@/types/domain";

export type { TradeMatchCandidate, TradeMatchResponse } from "@/types/domain";

export function lookupTradeMatchesForEmail(
  emailId: string,
  opts?: { limit?: number; scoreCutoff?: number; signal?: AbortSignal },
): Promise<TradeMatchResponse> {
  const params = new URLSearchParams({ emailId });
  if (opts?.limit !== undefined) params.set("limit", String(opts.limit));
  if (opts?.scoreCutoff !== undefined)
    params.set("scoreCutoff", String(opts.scoreCutoff));
  return apiClient.get<TradeMatchResponse>(
    `/api/trades/match-by-email?${params.toString()}`,
    { signal: opts?.signal },
  );
}
